import { DBFind, DBFindOne, ReduxInsert } from '@weblite/persist'
import { Hall } from '@weblite/ts-action/hall'
import { createStorage } from '../lib/storage'

const collection = 'halls'
const [storage, hallsReducer] = createStorage<Hall>(collection)

const findByIdentifier = (identifier: string) =>
  DBFindOne(collection, identifier, 'identifier') as Promise<Hall>

let loadedAll = false
async function dbGetAllHalls() {
  if (loadedAll) return storage.getAll()

  const res = (await DBFind(collection)) as Hall[]
  ReduxInsert(collection, res)
  loadedAll = true
  return res
}

const hallsStorage = { ...storage, findByIdentifier, dbGetAllHalls }

export { hallsStorage, hallsReducer }
